import React from 'react'
import propTypes from 'prop-types'
import FaIcon from '../FaIcon/FaIcon'

import './ExternalLink.scss'

const ExternalLink = ({ label, url }) => {
  const Icon = () => {
    return <FaIcon name='arrow-up-right-from-square' size={8} />
  }
  return (
    <a
      className='external-link'
      href={url}
      target='_blank'
      rel='noreferrer'
      draggable='false'>
      {/* prettier-ignore */}
      <>
        <span>{label}</span><Icon />
      </>
    </a>
  )
}

ExternalLink.propTypes = {
  label: propTypes.string.isRequired,
  url: propTypes.string.isRequired,
}

export default ExternalLink
